export const PHOTO_UPLOAD_READY = "photo-upload-ready"
export const PHOTO_READ_COMPLETE = "photo-upload-complete"